import { Headline } from '@ev-tech/ui-core-components/Headline';

import styles from './StickyHeader.module.css';

export const PriceDetailsText = ({ price, convertedPrice }: { price: string; convertedPrice?: string }) => {
  const priceDetails = `${price}${convertedPrice ? ` ${convertedPrice}` : ''}`;
  return <Headline className={styles.priceDetails} label={priceDetails} size="h6" as="p" />;
};
